import { LogoutEventServiceInterface } from '@src/server/services/types/logout-event.service.interface';
import { AxiosResponse } from 'axios';
import { AuditLogsApi } from 'cmp-client-api';

export class LogoutEventService implements LogoutEventServiceInterface {
  private readonly service: AuditLogsApi;

  public constructor(service: AuditLogsApi) {
    this.service = service;
  }

  public createAuditLogoutEvent(): Promise<AxiosResponse> {
    return this.service.createLogoutEvent();
  }
}
